
    var riot = require('riot')
    //src: starling/src/tags/comments/comments-container.html
riot.tag2('comments-container',
  '<popover size="XLarge" position="right" closable="{false}" type="blueish"> <comment each="{parent.getComments()}" canvas="{parent.parent.canvas}" instance="{this}" size="small"></comment> <new-comment-input node="{parent.node}" target="node" canvas="{parent.canvas}" commentscontainer="{parent}"></new-comment-input> </popover>',
  '',
  'class="node-comments" oncontextmenu="{ignoreClick}" onmousedown="{ignoreClick}" onclick="{ignoreClick}" ondblclick="{ignoreClick}"', function(opts) {
'use strict';

var _this = this;

var _commentsUi = require('lib/comments-ui');

var _opts = opts,
    node = _opts.node,
    target = _opts.target,
    canvas = _opts.canvas;

Object.assign(this, { node: node, target: target, canvas: canvas });

canvas.commentContainerTags[node.id] = this;

this.getComments = function () {
  var node = _this.node;

  var comments = [];

  if (node) {
    comments = canvas.store.nodeTopComments(node.id);
  }

  return comments;
};

this.updateAll = function () {
  var parent = _this.parent;

  _this.update();

  if (parent && parent.updateLayers) {
    parent.updateLayers();
  }
};

this.dismiss = function () {
  _commentsUi.commentsUI.unsetNewCommentOnNode();
  _commentsUi.commentsUI.hideCommentContainer(_this.node.id);

  _this.updateAll();
};

this.isShownCommentContainer = function () {
  return _commentsUi.commentsUI.isShownCommentContainer(_this.node.id);
};

this.ignoreClick = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};

this.on('update', function () {
  var newCommentInput = _this.newCommentInput,
      tags = _this.tags;
  var popover = tags.popover;

  if (_this.isShownCommentContainer()) {
    popover.show();
  } else {
    popover.hide();
    newCommentInput && newCommentInput.save();
  }
});

this.on('mount', function () {
  // avoid triggering node drag handlers
  $(_this.root).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comments-container')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comments-container.html
// module id = 794
// module chunks = 0